export default __webpack_public_path__ + "static/media/on-vessel-at-sea.57d251a3.svg";